import { axios } from "../../helper/axios";
import { ManufacturerTableconstant } from "./ManufacturerConstant";

const ManufacturerTableApi = {};

ManufacturerTableApi.getManufacturerTable = () => {
  return axios.get(ManufacturerTableconstant.MANUFACTURER_TABLE_API);
};
//post api
ManufacturerTableApi.postAddManufacturer = (payload) => {
  return axios.post(
    ManufacturerTableconstant.POST_ADD_MANUFACTURER_API,
    payload
  );
};

ManufacturerTableApi.getAddManufacturer = () => {
  return axios.get(ManufacturerTableconstant.GET_ADD_MANUFACTURER_API);
};

ManufacturerTableApi.getAddConnector = () => {
  return axios.get(ManufacturerTableconstant.GET_ADD_CONNECTORS_MODEL_API);
};

// ***********************

ManufacturerTableApi.postAddVehicleModel = (payload) => {
  return axios.post(
    ManufacturerTableconstant.POST_ADD_VEHICLE_MODEL_API,
    payload
  );
};

ManufacturerTableApi.postAddConnectorsModel = (payload) => {
  return axios.post(
    ManufacturerTableconstant.POST_ADD_CONNECTORS_MODEL_API,
    payload
  );
};

//get vehicl emodel api

ManufacturerTableApi.getvehicleModelApi = () => {
  return axios.get(ManufacturerTableconstant.GET_ADD_VEHICLE_MODEL_API);
};

// enable/disable
ManufacturerTableApi.VehicleManufatureEnableDisable = ({ id, status }) => {
  return axios.put(
    ManufacturerTableconstant.VEHICLEMANUFACTURE_ENABLE_DISABLE_API,
    {
      id: id,
      status: status,
    }
  );
};

ManufacturerTableApi.vehicleModelTypeId = () => {
  return axios.get(
    ManufacturerTableconstant.VEHICLE_MODEL_TYPE_API,
   
  );
};

//Manufacurer enable desable api

ManufacturerTableApi.ManufatureEnableDisableApi = ({ id, status }) => {
  return axios.post(ManufacturerTableconstant.MANUFACTURER_ENABLE_DISABLE_API, {
    id: id,
    status: status,
  });
};

ManufacturerTableApi.ConnectorsEnableDisable = ({ id, status }) => {
  return axios.put(ManufacturerTableconstant.CONNECTORS_ENABLE_DISABLE_API, {
    id: `${id}`,
    // api_id: id,
    status: status,
  });
};

// Add vehicle manufacture api

ManufacturerTableApi.AddVehicleManufatureEnableDisableApi = ({
  id,
  status,
}) => {
  return axios.put(
    ManufacturerTableconstant.ADD_VEHICLEMANUFACTURE_ENABLE_DISABLE_API,
    {
      id: id,
      status: status,
    }
  );
};

//update api

ManufacturerTableApi.UpdateAddManufacturer = (payload) => {
  return axios.put(
    ManufacturerTableconstant.UPDATE_ADD_MANUFACTURER_API,
    payload
  );
};

ManufacturerTableApi.UpdateAddConnector = (payload) => {
  return axios.put(ManufacturerTableconstant.UPDATE_ADD_CONNECTOR_API, payload);
};

ManufacturerTableApi.UpdateAddVehicalModel = (payload) => {
  return axios.put(
    ManufacturerTableconstant.UPDATE_ADD_VEHICLE_MODEL_API,
    payload
  );
};

//Get api select vehicle

ManufacturerTableApi.getSelectVehicle = () => {
  return axios.get(ManufacturerTableconstant.GET_SELECT_VEHICLE_API);
};

//Get api select vehicle

ManufacturerTableApi.getSelectVehicleModel = ({ payload }) => {
  return axios.get(ManufacturerTableconstant.GET_SELECT_VEHICLE_MODEL_API, {
    params: payload,
  });
};

//update put map

ManufacturerTableApi.UpdateMapApi = (payload) => {
  return axios.put(ManufacturerTableconstant.UPDATE_MAP_API, payload);
};

// add vehicle variant
ManufacturerTableApi.postAddVehicleVariantApi = (payload) => {
  return axios.post(
    ManufacturerTableconstant.POST_ADD_VEHICLE_VARIANT_API,
    payload
  );
};

//get vehicle variant
ManufacturerTableApi.getvehicleVariantApi = () => {
  return axios.get(ManufacturerTableconstant.GET_ADD_VEHICLE_VARIANT_API);
};

//edit vehicle variant
ManufacturerTableApi.UpdateAddVehicleVariant = (payload) => {
  return axios.put(
    ManufacturerTableconstant.UPDATE_ADD_VEHICLE_VARIANT_API,
    payload
  );
};

export { ManufacturerTableApi };
